import { DataTable } from '@/components/data-table'
import { openSheet } from '@/features/ui/store'
import type { Table } from '@/libs/table'
import { useEffectEvent } from 'react'
import type { TeamMember } from '../domain/member'
import { EmptyState, NoResults } from './empty-states'
import { useMemberParams } from './use-member-params'
import { GLOBAL_SHEET_IDS } from '@/features/ui/hooks/use-sheet'

type Props = {
	data: TeamMember[]
	hasFilters: boolean
	table: Table<TeamMember>
}

const sortableColumns = new Set(['name', 'position', 'department', 'status', 'startDate'])

const MembersTable = ({ data, hasFilters, table }: Props) => {
	const { setParams, sortBy, sortDir } = useMemberParams()

	const handleSort = useEffectEvent((key: string) => {
		if (sortBy !== key) {
			return setParams({ sortBy: key, sortDir: 'asc' })
		}
		if (sortDir === 'asc') {
			return setParams({ sortBy: key, sortDir: 'desc' })
		}
		setParams({ sortBy: null, sortDir: null })
	})

	if (!data.length && hasFilters) return <NoResults />
	if (!data.length) return <EmptyState />

	return (
		<DataTable
			table={table}
			sortBy={sortBy}
			sortDir={sortDir}
			sortableColumns={sortableColumns}
			onSort={handleSort}
			onRowClick={id => openSheet(GLOBAL_SHEET_IDS.MEMBER_DETAILS, id)}
			height='calc(100vh - 200px)'
		/>
	)
}

export { MembersTable }
